/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Page_Hours_TitleInputs */

const en_start_page_hours_title = /** @type {(inputs: Start_Page_Hours_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set your hours once.`)
};

const pl_start_page_hours_title = /** @type {(inputs: Start_Page_Hours_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Godziny ustawiasz raz.`)
};

/**
* | output |
* | --- |
* | "Set your hours once." |
*
* @param {Start_Page_Hours_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const start_page_hours_title = /** @type {((inputs?: Start_Page_Hours_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Page_Hours_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_start_page_hours_title(inputs)
	return en_start_page_hours_title(inputs)
});